module.exports = __webpack_public_path__ + "img/syndrome.8e84bd45.svg";